import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-784c4779"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "good-tags"
}
const _hoisted_2 = { class: "good-tags-tag__name" }




export default /*#__PURE__*/_defineComponent({
  __name: 'MTabs2',
  props: {
  tabs: { type: Array, default: () => [] },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (__props.tabs.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tag) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tag,
            class: "good-tags-tag"
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(tag), 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})